// extracted by mini-css-extract-plugin
export default {"wrapper":"Agregates_wrapper__OWh09","infiniteLoader":"Agregates_infiniteLoader__SMrQg","spin":"Agregates_spin__+ydbO"};